import { useCurrentTimestamp } from "@tellescope/ui";
import { Select } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import { getTimezoneName } from "../../utils";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export type TimezoneSelectOption =
  | "America/New_York"
  | "America/Chicago"
  | "America/Denver"
  | "America/Los_Angeles"
  | "America/Juneau"
  | "Pacific/Honolulu"
  | "GMT"
  | "CET"
  | "JST"
  | "Asia/Shanghai"
  | "Australia/Sydney";

export interface TimezoneSelectItemProps {
  timezone: TimezoneSelectOption;
}

export const TimezoneSelectItem = forwardRef<HTMLDivElement, TimezoneSelectItemProps>(({ timezone }, ref) => {
  const { format, formatInTimeZone } = useDateFnsFormattersWithLocale();
  const { t, i18n } = useTranslation("calendar");
  const isDefaultTimezone = format(new Date(), "zzz") === formatInTimeZone(new Date(), timezone, "zzz");
  const currentTimestamp = useCurrentTimestamp({ pollingRateInMs: 1000 * 60, snapTo: "minute" });

  return (
    <Select.Item data-testid={`calendar-timezone-item-${timezone}`} value={timezone} ref={ref}>
      {getTimezoneName(timezone, "longGeneric", i18n.language)}
      {isDefaultTimezone ? t(" (D)") : ""}
      <span className="text-muted-foreground pl-2">{formatInTimeZone(currentTimestamp, timezone, "h:mm a")}</span>
    </Select.Item>
  );
});
